import React from "react";

const Loading = () => (
  <div className="progress">
    <div className="indeterminate" />
  </div>
);

export default Loading;
